import { styled } from "@mui/material";
const TextFieldLabel = styled("span")(({ required, theme }) => ({
  "&::before": {
    content: required ? "'*'" : void 0,
    color: theme.palette.error[500]
  }
}));
export {
  TextFieldLabel
};
